import React from "react";
import PropTypes from "prop-types";

import TextField from "@mui/material/TextField/TextField";
import Stack from "@mui/material/Stack";


const StepContact = (props) => {
    const {formik} = props

    return <Stack direction="column" spacing={3} sx={{mt: 1}}>
        <TextField
            required
            name="mail"
            value={formik.values.mail}
            onChange={formik.handleChange}
            error={formik.touched.mail && Boolean(formik.errors.mail)}
            helperText={formik.touched.mail && formik.errors.mail}
            label="Email"
            fullWidth
        />

        <TextField
            name="phone"
            value={formik.values.phone}
            onChange={formik.handleChange}
            error={formik.touched.phone && Boolean(formik.errors.phone)}
            helperText={formik.touched.phone && formik.errors.phone}
            label="Numero di telefono (facoltativo)"
            fullWidth
        />

        <TextField
            name="mobilePhone"
            value={formik.values.mobilePhone}
            onChange={formik.handleChange}
            error={formik.touched.mobilePhone && Boolean(formik.errors.mobilePhone)}
            helperText={formik.touched.phone && formik.errors.mobilePhone}
            label="Numero di cellulare (facoltativo)"
            fullWidth
        />
    </Stack>
}

StepContact.propTypes = {
    formik: PropTypes.object.isRequired
};

export default StepContact;